import request from '@/utils/request'

// 查询列表
export function apiScpMrpBomStructuresItemUselist (data) {
  return request({
    url: '/scp/scpMrpBomStructures/itemUselist',
    method: 'post',
    data: data
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}
